// 此文件由脚本自动生成，请勿直接修改。
// This file was generated automatically by a script. Please do not modify it directly.

import { StepsTokens } from './type';

const stepsTokens: StepsTokens = {
  stepsDescriptionFontColor: 'Neutral-text-3',
  stepsDescriptionTitleMarginX: 'Margin-4',
  stepsIconWidth: 'Size-14',
  stepsIconHeight: 'Size-14',
  stepsIconFontSize: '16/regular',
  stepsSmallIconWidth: 'Size-12',
  stepsSmallIconHeight: 'Size-12',
  stepsSmallIconFontSize: '14/regular',
  stepsLargeIconWidth: 'Size-16',
  stepsLargeIconHeight: 'Size-16',
  stepsLargeIconFontSize: '18/regular',
  stepsTitleFontSize: '16/regular',
  stepsSmallTitleFontSize: '14/medium',
  stepsSmallDescriptionFontSize: '12/regular',
  stepsLargeTitleFontSize: '18/medium',
  stepsLargeDescriptionFontSize: '12/regular',
  stepsWaitFontColor: 'Neutral-text-4',
  stepsWaitBackgroundColor: 'Neutral-fill-2',
  stepsProcessFontColor: 'Neutral-text-1',
  stepsProcessBackgroundColor: 'Brand-6',
  stepsFinishFontColor: 'Brand-6',
  stepsFinishBackgroundColor: 'Brand-1',
  stepsErrorFontColor: 'Neutral-text-1',
  stepsErrorBackgroundColor: 'Danger-6',
  stepsArrowPaddingX: 'Padding-16',
  stepsArrowPaddingY: 'Padding-8',
  stepsArrowHeight: 'Size-32',
  stepsSmallArrowPaddingX: 'Padding-16',
  stepsSmallArrowPaddingY: 'Padding-5',
  stepsSmallArrowHeight: 'Size-28',
  stepsLargeArrowPaddingX: 'Padding-16',
  stepsLargeArrowPaddingY: 'Padding-11',
  stepsLargeArrowHeight: 'Size-36',
  stepsTailBackgroundColor: 'Neutral-border-1',
  stepsTailFinishBackgroundColor: 'Brand-6',
  stepsNearlyContentMargin: 'Margin-8',
  stepsNearlyDescribeMargin: 'Margin-4',
};

export default stepsTokens;
